import { css } from 'styled-components';

export const footerCss = css`
  ul {
    list-style: disc;
    padding-left: 20px;
  }

  .important {
    font-weight: bold;
  }
`;
